import { render, staticRenderFns } from "./DashboardModule.vue?vue&type=template&id=d4751d92&scoped=true&"
import script from "./DashboardModule.vue?vue&type=script&lang=js&"
export * from "./DashboardModule.vue?vue&type=script&lang=js&"
import style0 from "./DashboardModule.vue?vue&type=style&index=0&id=d4751d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4751d92",
  null
  
)

export default component.exports